import { initAppConfig } from "./common/config/appConfig";
import appConfig, { appConfigSchema } from "./config/AppConfig";
import applyDocumentBranding from "./config/applyDocumentBranding";
import renderConfigError, { renderLoadError } from "./config/renderConfigError";

// Nothing that reads configuration at module load may be imported statically
// here (App, i18n, api, storage). It is loaded by ./bootstrap after validation.

// Every client's static/ is byte-identical and only app-config.js differs, so a deployment copied
// onto the wrong site would silently run another client's API URL and keys. Report it loudly.
// It only warns and never blocks rendering: a legitimate host alias, a proxy or a different
// port (publicUrl carries one in local development) must keep working.
const warnOnHostMismatch = (publicUrl: string) => {
  try {
    const expected = new URL(publicUrl).host;
    if (window.location.host !== expected)
      console.error(
        `This deployment is configured for "${expected}" but is being served from "${window.location.host}". ` +
          "Check that the right client's app-config.js was deployed to this site."
      );
  } catch {
    // publicUrl is not an absolute URL; the schema validation reports that, nothing to compare.
  }
};

const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");

const { errors } = initAppConfig(appConfigSchema, { requireRuntime: true });
if (errors.length > 0) {
  renderConfigError(container, errors);
} else {
  const config = appConfig();
  applyDocumentBranding(config);
  warnOnHostMismatch(config.publicUrl);
  import("./bootstrap")
    .then(({ default: start }) => start(container))
    .catch((error) => renderLoadError(container, error));
}
